'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('systemOwnerReviewControllers.DecommissionSystems')

.factory('decommissionSystemsService', ['$http', '$q', function ($http, $q) {

    var service = {};

    var baseUrl = environment.apiUrl + '/ID/SystemOwner/Review/API';

    // **** HttpGet

    service.getSystemsToToggleSetForDecommission = function (authLogin) {
        return $http.get(baseUrl + '/BySystemOwner/' + authLogin +
                         '/DecommissionSystems/System', {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // **** HttpPost

    service.toggleSetForDecommission = function (authLogin, system) {
        return $http.post(baseUrl + '/BySystemOwner/' + authLogin +
                         '/DecommissionSystems/System/ToggleSetForDecommission/', system)
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.confirmReview = function (authLogin, systems) {
        var systemIdList = _.map(systems, 'SystemID');

        return $http.post(baseUrl + '/BySystemOwner/' + authLogin +
                          '/DecommissionSystems/System/Confirm', {
                              systemIdList: systemIdList
                          })
                    .then(function (response) {
                        return response.data;
                    });
    }



    return service;
}]);
